import React from 'react'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import SearchTabs from './SearchTabs'
import HandleMarkup from '@src/components/HandleMarkup'
import { useSearchContext } from './SearchContext'
import getConfig from 'next/config'
import SearchResultsToggleBanner from '@src/components/SearchResultsToggleBanner'
import { FACET_SEARCH } from '@src/utils/termlessSearch'
import DocumentSearchBanner from './SearchResultsGrid/DocumentSearchBanner'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

const useStyles = makeStyles()((theme) => ({
  noResults: {
    marginTop: 0,
  },
  titleWrapper: {
    borderLeft: `4px solid ${theme.palette.rich.purple}`,
    paddingLeft: theme.spacing(2.5),
  },
  title: {
    marginLeft: theme.spacing(2),
    textTransform: 'capitalize',
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
    },
  },
  toggleBanner: {
    width: 'auto',
  },
  docSearchBanner: {
    display: 'flex',
    marginTop: theme.spacing(4),
  },
}))

// TODO - Cleanup 2 exports after structureSearchResult, B2BProductSearchResults component refactoring
export enum ViewPreference {
  grid,
  list,
}

export interface ViewPreferenceProps {
  view: ViewPreference
  setView: (view: ViewPreference) => void
}

const SearchResults: React.FC = () => {
  const { classes } = useStyles()
  const { hasResults, searchTerm, facetTerm, isDocumentSearch } =
    useSearchContext()
  const displayTerm = searchTerm === FACET_SEARCH ? facetTerm : searchTerm

  return (
    <div className={hasResults ? undefined : classes.noResults}>
      {featureFlags.newSrp && (
        <SearchResultsToggleBanner
          className={classes.toggleBanner}
          currentExperience={'new'}
        />
      )}
      <div className={classes.titleWrapper}>
        <Typography variant="h1" className={classes.title}>
          <HandleMarkup value={displayTerm || ''} />
        </Typography>
      </div>
      {isDocumentSearch && (
        <div className={classes.docSearchBanner}>
          <DocumentSearchBanner searchQuery={searchTerm.toLowerCase()} />
        </div>
      )}
      <SearchTabs />
    </div>
  )
}

export default SearchResults
